import { ExplorationFlagsType, getDefaultFlags } from './flags';
import { atom } from 'jotai';

// --------------------------------------------------------------------------

export const explorationFeatureFlagAtom =
  atom<ExplorationFlagsType>(getDefaultFlags());
